/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from '../../constants/Colors';
import {Breakpoints} from "../../constants/Breakpoints";

const Surface_OLD = styled.div`
  padding: 12px;
  background-color: ${Colors.WHITE};
  border: 1px solid ${Colors.GRAY[5]};
  border-radius: 16px;
  box-shadow: 0px 8px 6px rgba(0, 0, 0, 0.1);
  margin: 0px 10px 0px 10px;
  
  @media (min-width: ${Breakpoints.lg}) {
    margin: unset;
  }
`;

const Surface = styled.div`
  padding: 2.5rem 0 1rem;
  border-radius: 15px
  background-color: ${Colors.WHITE};
  border: 4px solid ${Colors.BLUE};
  box-shadow: 0px 5px 20px 5px rgba(0,0,0,0.1);

  @media screen and (min-width: ${Breakpoints.sm}) {
    min-height: 385px;
    position: relative;
  }
  
  @media (min-width: ${Breakpoints.sm}) {
    padding: 2rem 4rem;
    border-radius: 40px;
  }
`;

export default Surface;